<script>
import NavBar from '@components/nav-bar'
import NavegacaoV2Shell from '@modules/navegacao-v2/components/navegacao-v2-shell.vue'
import { isNav2026Enabled } from '@modules/navegacao-v2/utils/nav2026-enabled'
import con from '@connection'
import Snackbar from '@components/the-snackbar'
import BigSnackbar from '@modules/global/components/big-snackbar.vue'
import Modal from '@modal/the-feedback'
import SnackModal from '@modal/the-snack-modal.vue'
import TheNewVersionModal from '@modal/the-new-version-modal.vue'
import ModalVideos from '@modal/show-videos'
import ModalReleaseNotes from '@modal/show-release-notes'
import ModalReleaseNotesClient from '@modal/show-release-notes-client'
import SimuladorDetalhes from '@modal/simulador-detalhes'
import ConversaoRating from '@modal/conversao-rating'
import { adicionarTransacao, simulador } from '@constants/URL'
import { MODAL, RELOAD, CANT_ACCESS_FUNCTION, FEATURES } from '@constants/Text'
import { SHOW_ATENDIMENTO_BLACKLIST } from '@modules/atendimento/constants/Text.js'
import ChatPopup from '@components/chat-popup'
import SendComponent from '@modal/workspace/send-component'
import { possivelJSON } from '@utils/Format'
import { deveVerSoFeeFixo } from '@utils/escritorioFeeFixoMigracao'
import { deveMostrarChatIaWidget } from '@modules/global/utils/chat-ia-widget-visivel'
import { GlobalBus } from '@services/bus'
import store from '@state/store'
import { CURRENT_RELEASE } from '@modules/global/constants/CurrentRelease'
import {
  isReleaseDismissed,
  isReleaseExpired,
} from '@modules/global/utils/release-modal-storage'
import ReleaseAnnouncement from '@modules/global/modal/release-announcement/release-announcement.vue'

import ChatIaPopUp from '@/src/modules/global/components/chat-ia-pop-up/chat-ia-pop-up.vue'
import AtendimentoPopup from '@modules/atendimento/components/atendimento-popup/atendimento-popup.vue'
import ModalQrcodeConexao from '@modules/settings/modal/atendimento/modal-qrcode-conexao/modal-qrcode-conexao.vue'
import ModalTermosAtendimento from '@modules/settings/modal/atendimento/modal-termos-atendimento/modal-termos-atendimento.vue'
import TriggerSuggesterModal from '@modules/tarefas/modal/trigger-suggester-modal/trigger-suggester-modal.vue'
import GlobalModals from '@components/global-modals'
import CentralConfigGuideDrawer from '@modules/central-config/components/central-config-guide-drawer/central-config-guide-drawer.vue'
import CentralConfigTourGuiado from '@modules/central-config/components/central-config-tour-guiado/central-config-tour-guiado.vue'
import { restoreGuide } from '@modules/central-config'
import FeeFixoIaEspecialista from '@modules/fee-fixo/components/fee-fixo-ia-especialista/fee-fixo-ia-especialista.vue'
import ConsultorPainel from '@modules/solicitacoes/components/consultor-painel/consultor-painel.vue'
import { temAcessoIaFeeFixo } from '@modules/fee-fixo/utils/acesso-ia'
import FloatingDockToggle from '@modules/global/components/floating-dock-toggle/floating-dock-toggle.vue'
import {
  readDockCollapsed,
  writeDockCollapsed,
  hasRegisteredDockWidgets,
  FLOATING_DOCK_ID,
} from '@modules/global/utils/floating-dock-state'
import {
  resolveSimulacaoStatus,
  isSimulacaoRunning,
} from './simulacao-status'

export default {
  components: {
    NavBar,
    NavegacaoV2Shell,
    GlobalModals,
    Snackbar,
    BigSnackbar,
    Modal,
    SnackModal,
    TheNewVersionModal,
    ModalVideos,
    ModalReleaseNotes,
    ModalReleaseNotesClient,
    SimuladorDetalhes,
    ConversaoRating,
    ChatPopup,
    SendComponent,
    ReleaseAnnouncement,
    ChatIaPopUp,
    AtendimentoPopup,
    ModalQrcodeConexao,
    ModalTermosAtendimento,
    TriggerSuggesterModal,
    FloatingDockToggle,
    CentralConfigGuideDrawer,
    CentralConfigTourGuiado,
    FeeFixoIaEspecialista,
    ConsultorPainel,
  },
  data() {
    return {
      isComponentDestroyed: false,
      pollingTimersSimulation: {},
      pollingTimerAccounts: null,
      toTop: false,
      expandPanel: false,
      accounts: [],
      accountAtt: false,
      atualizando: false,
      show_simulacoes_running: true,
      // loadingSimulacoes: 0,
      simulations: {},
      loadingAccounts: false,
      panel: 0,
      // Dock recolhível dos atalhos flutuantes (IA, Atendimento)
      dockCollapsed: false,
      FLOATING_DOCK_ID,
    }
  },
  computed: {
    // Liga a nova navegação 2026 (sidebar de contexto) quando a flag está ativa.
    // Render condicional no template — a navegação atual segue intacta sem a flag.
    navUsaV2() {
      return isNav2026Enabled(store.getters['parameters/show'])
    },
    // Rota imersiva: o miolo vai pelo `NavegacaoV2Shell` com `sem-sidebar`
    // (na nav v1 cai no `NavBar` comum — ver o comentário do template) — hoje
    // só a visão de tela cheia do chat de IA. Os modais globais
    // (Snackbar/SnackModal/GlobalModals) continuam montados abaixo do switch, e
    // é por isso que a visão imersiva mora aqui e não fora do <Layout>: o chat
    // chama `$showSnack`, e erro de stream sem snack vira silêncio.
    //
    // DERIVADO da rota, nunca um flag gravado. O comentário de `routeAllowsMobile`
    // (app.vue) registra o bug do caminho contrário: um flag setado uma vez e
    // nunca revertido liberou o app inteiro pelo resto da sessão. Como computed,
    // sair da rota restaura o chrome em todos os caminhos — link, back, F5.
    rotaImersiva() {
      return !!(this.$route && this.$route.meta && this.$route.meta.imersivo)
    },
    // ★ Modo RESTRITO (`meta.restrito`, spec-001 onboarding-v2): a rota ocupa a
    // tela inteira sem NENHUM chrome da plataforma — sem sidebar, sem topbar,
    // sem os atalhos flutuantes e sem o bloco de modais globais. Hoje só a
    // Lista de Espera (`professional-waitlist/routes.js`), onde o profissional
    // ainda não tem plataforma para navegar: qualquer pedaço de menu ali é uma
    // porta para uma tela que o guard vai fechar de volta.
    //
    // ⚠️ NÃO é o `meta.imersivo`, e copiá-lo NÃO resolveria — medido em
    // 21/09/2026 contra o Postgres local:
    //   1. `imersivo` só age na nav v2 (o `:sem-sidebar` do shell abaixo), e o
    //      público-alvo está na v1 — o escritório 5914, onde a landing
    //      cadastra (54 profissionais, todos `id_role=3`), NÃO tem a flag
    //      `navegacao_2026`. Na v1 o `imersivo` só garante que o slot não vá
    //      nu, e o NavBar continua inteiro;
    //   2. mesmo na v2, `sem-sidebar` mantém a TOPBAR
    //      (`navegacao-v2-shell.vue:114` renderiza `NavTopbar` sempre);
    //   3. `imersivo` não alcança os modais globais — eles moram ABAIXO do
    //      switch de nav de propósito (o chat imersivo chama `$showSnack`).
    //
    // DERIVADO da rota, nunca um flag gravado — mesmo racional do
    // `rotaImersiva` acima: sair da rota restaura o chrome em todos os
    // caminhos (link, back, F5).
    rotaRestrita() {
      return !!(this.$route && this.$route.meta && this.$route.meta.restrito)
    },
    // Feature flag da Jornada (2026-07-29). O drawer-guia e o loader nomeado são montados
    // AQUI, no layout, fora das rotas — o `can_show` da rota não os alcança. Sem este
    // gate, um escritório sem a funcionalidade continuaria vendo o painel restaurado do
    // localStorage (`cc_guide_<escritorio>_<usuario>`), que sobrevive a reload.
    jornadaHabilitada() {
      const show = store.getters['parameters/show'] || {}
      return !!show[FEATURES.CENTRAL_CONFIG]
    },
    // Flag + escopo de rota, mesmo par `feeFixoIaHabilitada`/`feeFixoIaVisivel`
    // logo abaixo. A Jornada é o único painel global SEM escopo de rota — de
    // propósito, ela precisa seguir o usuário por outros módulos. A visão
    // imersiva é a exceção: o drawer é 380px e o tour desenha spotlight sobre
    // elementos da plataforma que ali não existem.
    jornadaVisivel() {
      return this.jornadaHabilitada && !this.rotaImersiva
    },
    // Painel do guia da Central de Configuração ABERTO (não recolhido) — desloca
    // o conteúdo à direita e esconde o dock. Quando recolhido (FAB), o dock volta.
    // Só desloca quando a Jornada está VISÍVEL: sem a flag (ou na visão imersiva)
    // o painel nem renderiza, e o layout não pode reservar 380px para um
    // componente que não existe.
    ccGuideOpen() {
      if (!this.jornadaVisivel) return false
      return !!store.getters['centralConfig/guidePanelOpen']
    },
    // Especialista Fee-Based (painel lateral). Montado GLOBALMENTE (fora das
    // rotas, como CentralConfigGuideDrawer) para sobreviver à `key` do
    // RouterView (src/app.vue:50). Por isso o `can_show: FEATURES.FEE_FIXO`
    // das rotas do módulo NÃO alcança este componente — sem checar a flag do
    // MÓDULO aqui (e não só a da IA), um escritório com IA_FEE_FIXO ligada
    // sem o módulo veria o painel em qualquer rota do app.
    feeFixoIaHabilitada() {
      const show = store.getters['parameters/show'] || {}
      return !!show[FEATURES.FEE_FIXO] && temAcessoIaFeeFixo(this.$access)
    },
    // Escopo por rota: o contexto do Especialista (premissas, cliente ativo,
    // rascunho do Fee Lab) só existe dentro do módulo. Fora dele, squeezar a
    // tela por um painel sem contexto pra responder ali seria pior UX que
    // ocultá-lo — diferente do guia da Jornada, que PRECISA seguir o usuário
    // por outros módulos, de propósito.
    emFeeFixo() {
      const nome = this.$route && this.$route.name
      return !!nome && nome.indexOf('fee-fixo') === 0
    },
    // ★ A entrada em conversa (`fee-fixo.guia`, spec-001 do onboarding) usa a
    // MESMA store (`feeFixoIa`) deste painel — é a mesma conversa, em tela
    // cheia. Montar os dois na mesma rota mostraria o thread duplicado, com
    // dois inputs escrevendo nele; e recolher o painel não resolveria, porque
    // `painelAberto` sobrevive à navegação de propósito (US-4/spec-016).
    naEntradaDoGuia() {
      const nome = this.$route && this.$route.name
      return nome === 'fee-fixo.guia'
    },
    feeFixoIaVisivel() {
      return (
        this.feeFixoIaHabilitada && this.emFeeFixo && !this.naEntradaDoGuia
      )
    },
    // Painel ABERTO (não recolhido pra aba) — desloca o conteúdo, mesmo
    // padrão de `ccGuideOpen`. `false` quando o componente nem está visível:
    // não há squeeze sem painel na tela. Não reseta `painelAberto` ao sair do
    // módulo — só a VISIBILIDADE é escopada; o Vuex é o que já preserva a
    // conversa entre navegações (US-4/spec-016), e resetar aqui destruiria a
    // própria razão de o estado morar lá.
    ffIaPanelOpen() {
      if (!this.feeFixoIaVisivel) return false
      return !!store.getters['feeFixoIa/painelAberto']
    },
    // Altura real da navbar ativa: legado (`v-app-bar` padrão Vuetify,
    // nav-bar.vue) = 64px; nav v2 (`.nav-topbar`, topbar.vue) = 44px
    // explícito. O painel do Especialista usa isto pra nunca sobrepor a
    // busca Ctrl+K da topbar (`top: 0` sobrepõe — ver o comentário no
    // próprio componente).
    // Um nome só desde que o painel do Fee Fixo passou a usar a casca
    // compartilhada: antes `--ff-ia-top-offset` e `--ia-painel-top-offset`
    // recebiam o MESMO valor com dois nomes.
    //
    // O comentário mora AQUI, e não dentro da expressão `:style` do template:
    // um `//` lá dentro compila só enquanto as quebras de linha sobrevivem —
    // qualquer passo que colapse o atributo comentaria o resto do objeto e a
    // custom property sumiria SEM erro de build.
    iaPainelTopOffset() {
      return this.navUsaV2 ? '44px' : '64px'
    },
    // Consultor Estratégico como painel do AAWZ Hub. Montado aqui, e não pela
    // view, porque o squeeze é `padding-right` na RAIZ do layout — a view não
    // alcança o ancestral de tudo.
    //
    // Escopo por rota, como o Especialista: só na Visão Geral do Hub, que é
    // onde o contexto (ciclo, trilha, catálogo) está na tela. A rota dedicada
    // `solicitacoes.consultor` fica DE FORA de propósito — ela já monta um
    // `ViewChat` no namespace `aawz-intelligence-v2`, e dois no mesmo store
    // brigariam pela mesma conversa.
    consultorPainelVisivel() {
      const nome = this.$route && this.$route.name
      if (nome !== 'solicitacoes.visao-geral') return false
      return !!this.$access[FEATURES.SOLICITACOES]
    },
    consultorPainelOpen() {
      if (!this.consultorPainelVisivel) return false
      return !!store.getters['solicitacoes/consultorPainelAberto']
    },
    // Precedência entre os dois painéis laterais que podem coexistir (Jornada
    // + Especialista): a Jornada vence — é um fluxo guiado ativo, não deve
    // mudar de largura por acaso o Especialista também estar aberto. Resolvida
    // aqui, na classe (não mais via `:style` inline — ver `.has-cc-guide`/
    // `.has-ff-ia-panel` no `<style>`): só uma das duas classes fica ativa por
    // vez, então o `padding-right` de cada uma pode morar na PRÓPRIA regra CSS.
    ffIaSqueezeAtivo() {
      return this.ffIaPanelOpen && !this.ccGuideOpen
    },
    // Mesma precedência do Especialista: a Jornada vence. Não há regra entre o
    // Especialista e o Consultor porque eles são disjuntos por rota
    // (`fee-fixo*` × `solicitacoes.visao-geral`) — nunca estão na mesma tela.
    consultorSqueezeAtivo() {
      return this.consultorPainelOpen && !this.ccGuideOpen
    },
    // ★ Nav v2 (John, 05/08/2026): o topbar (busca/data/avatar) precisa ir até
    // a borda direita da tela, por trás do painel — não parar onde o painel
    // começa. Squeezar o `<div>` raiz inteiro (como o v1 faz) squeezaria o
    // topbar junto. Por isso, com nav v2, o padding-right NÃO vai na raiz
    // (ver template/style abaixo): vai só no slot de conteúdo do
    // NavegacaoV2Shell, via esta prop — o `<main>`/topbar do shell ficam de
    // fora, sempre largura cheia. As classes `has-cc-guide`/`has-ff-ia-panel`
    // continuam presentes na raiz nas duas versões de nav (só o
    // padding-right delas é que fica restrito ao v1) — é o que permite
    // `_modal.sass` continuar deslocando modal em qualquer versão.
    contentPaddingRightV2() {
      if (!this.navUsaV2) return ''
      if (this.ccGuideOpen) return '380px'
      // Um valor só para os dois painéis de IA, lido da custom property que a
      // partial `_ia-painel-lateral.sass` declara — antes o `clamp` estava
      // escrito aqui, na regra CSS e no componente, e derivava.
      if (this.ffIaSqueezeAtivo || this.consultorSqueezeAtivo) {
        return 'var(--ia-painel-largura)'
      }
      return ''
    },
    usuarioAtual() {
      return store.getters['user/currentUser'] || {}
    },
    simulacoes() {
      return store.getters['simulador/getRunning'] || []
    },
    paginaAtual() {
      return this.$route.name || ''
    },
    loadingSimulacoes() {
      return this.simulacoes.filter((s) => {
        return s.status_simulacao === '100'
      }).length
    },
    // Mesma FONTE que o ChatIaPopUp.showPopUp, não mais um espelho dela: as duas
    // cópias tinham divergido (`alteracoes-ia` só constava lá), e era esta aqui
    // que decidia sozinha se o handle do dock tinha o que recolher — daí o
    // handle órfão. Ver `utils/chat-ia-widget-visivel.js`.
    showChatIaWidget() {
      return deveMostrarChatIaWidget({
        routeName: this.$route.name,
        user: this.$currentUser(),
        access: this.$access,
      })
    },
    // Espelha AtendimentoPopup.shouldRender — nunca pro cliente final, feature
    // Atendimento ligada e rota fora do blacklist (onde a view cheia já cobre
    // a tela). `$access[ATENDIMENTO]` é equivalente a `$canAccess(ATENDIMENTO)`
    // (ambos leem `parameters.show[attr]`).
    showAtendimentoWidget() {
      if (this.$currentUser().IS_CLIENTE) return false
      // Mesma regra de showChatIaWidget acima — espelha
      // AtendimentoPopup.shouldRender.
      if (deveVerSoFeeFixo(this.$currentUser())) return false
      if (!this.$access[FEATURES.ATENDIMENTO]) return false
      return !SHOW_ATENDIMENTO_BLACKLIST.includes(this.$route.name)
    },
    // O handle do dock só faz sentido quando há pelo menos um atalho flutuante
    // para recolher. Sem widget visível, não renderiza a aba (evita o handle
    // órfão em escritórios sem IA nem Atendimento). Soma também widgets
    // registrados fora desta árvore (ex.: OptionsTourManual, montado por ~17
    // views próprias) — senão um FAB desses fica sem handle pra recolher quando
    // nenhum dos 2 widgets acima está visível (ex.: cliente final, ou
    // escritório sem essas features).
    hasDockWidgets() {
      return (
        this.showChatIaWidget ||
        this.showAtendimentoWidget ||
        hasRegisteredDockWidgets()
      )
    },
  },
  created() {
    // Override de dev (localStorage.nav2026) liga a navegação 2026: reflete a flag
    // no store para que o guard de rota (meta.can_show) também a reconheça e não
    // mande o gateway "Clientes" (nav2.clientes) para 404.
    if (this.navUsaV2) {
      store.dispatch('parameters/updateShowModule', {
        module: FEATURES.NAVEGACAO_2026,
        value: true,
      })
    }
    // Escritório sem a flag da Jornada: descarta o guia persistido em vez de só não
    // renderizar. Sem isto, o guia fica no localStorage apontando para uma etapa de
    // um catálogo que pode mudar — e o painel reabriria com contexto velho se a flag
    // voltasse meses depois. `closeGuide` já zera o Vuex E o storage (writeGuide).
    //
    // Com a flag ligada, é AQUI que o guia persistido é restaurado — e não no
    // registro do módulo (bootstrap), porque a chave é carimbada por escritório +
    // usuário e o usuário só existe depois do guard do router. Ver
    // `@modules/central-config/index.js` `restoreGuide`.
    if (this.jornadaHabilitada) {
      restoreGuide({ store })
    } else {
      store.dispatch('centralConfig/closeGuide')
    }
    GlobalBus.$on(RELOAD.ATT_BANKS, this.onReloadBanks)
    GlobalBus.$on('attOneBank', this.onReloadOneBank)
    GlobalBus.$on(RELOAD.SIM_RUNNING, this.carregarSimulacoes)

    // Restaura a preferência de recolhimento do dock de atalhos flutuantes.
    this.dockCollapsed = readDockCollapsed()

    // Utilizado para mostrar um modal apresentando as novidades da plataforma
    this.showReleaseModal()

    // A permissão de notificação NÃO é mais pedida aqui.
    //
    // O bloco anterior chamava `Notification.requestPermission()` no load do
    // app, e a condição (`!== 'denied' || === 'default'`) era sempre verdadeira
    // — inclusive com a permissão já concedida, quando o segundo termo era
    // ainda por cima inalcançável. Pior que a redundância: pedia a permissão
    // sem contexto e sem criar inscrição nenhuma, então quem concedia não
    // passava a receber nada, e os navegadores penalizam site que pede
    // permissão fora de uma ação do usuário (o Chrome troca o diálogo por um
    // aviso discreto e o pedido some).
    //
    // A permissão passou a ser pedida no momento em que o profissional liga o
    // push de propósito — em `apiPushSubscription.ativar()`, que na sequência
    // cria a inscrição e a registra no backend.

    // TODO: se necessario abrir na ultima pagina
    // if (this.$configLocal().last_page) {
    //   this.$router.push({ name: this.$configLocal().last_page })
    // }

    this.carregarSimulacoes()
  },
  beforeDestroy() {
    this.isComponentDestroyed = true
    Object.values(this.pollingTimersSimulation).forEach(clearTimeout)
    this.pollingTimersSimulation = {}
    clearTimeout(this.pollingTimerAccounts)
    GlobalBus.$off(RELOAD.SIM_RUNNING, this.carregarSimulacoes)
    GlobalBus.$off(RELOAD.ATT_BANKS, this.onReloadBanks)
    GlobalBus.$off('attOneBank', this.onReloadOneBank)
  },
  methods: {
    async carregarSimulacoes() {
      // if (this.loadingSimulacoes) {
      //   return
      // }
      if (this.$currentUser().IS_CLIENTE) {
        return
      }
      store.dispatch('simulador/setLoading', true)
      try {
        let r = await con.get(simulador.lista_detalhes)
        let sims = []
        if (r.status === 200 && Array.isArray(r.value)) {
          sims = r.value.filter((s) => {
            return s.status_simulacao === '100'
          })
        }
        if (Array.isArray(r.value)) {
          store.dispatch('simulador/setRunning', r.value)
        } else {
          store.dispatch('simulador/setRunning', [])
        }
        if (sims && sims.length) {
          sims.forEach((s) => {
            this.checkStatusSimulation(s)
          })
        }
      } finally {
        store.dispatch('simulador/setLoading', false)
      }
    },
    async checkStatusSimulation(sim) {
      const data = {
        id_cliente: sim.id_cliente || sim.id_cliente_app,
        simulation_hash_code: sim.hash_code,
      }
      const r = await con.post(simulador.status, data)
      const value = r && r.value ? r.value : null
      const isRunning = isSimulacaoRunning(value)
      const timerKey = sim.hash_code || sim.hash

      if (value) {
        const step = typeof value.step === 'number' ? value.step : 0
        let progress = 1
        if (step === -1) {
          progress = 98
        } else if (value.n_steps) {
          progress = (step / value.n_steps) * 100
        }
        const prev = this.simulations[timerKey]
        let load = 1
        if (prev) {
          load = progress > prev.load ? progress + 2 : prev.load + 2
        }
        const nextStatus = resolveSimulacaoStatus(r.status, value)
        const aux = {
          ...sim,
          load,
          status_simulacao: nextStatus,
        }
        store.dispatch('simulador/updateRunning', aux)
        this.simulations[timerKey] = {
          hash: value.hash_code,
          status_simulacao: nextStatus,
          load: load,
        }
      }

      if (isRunning) {
        if (this.pollingTimersSimulation[timerKey]) {
          clearTimeout(this.pollingTimersSimulation[timerKey])
        }
        this.pollingTimersSimulation[timerKey] = setTimeout(() => {
          if (!this.isComponentDestroyed) this.checkStatusSimulation(sim)
        }, 15000)
      } else {
        if (this.pollingTimersSimulation[timerKey]) {
          clearTimeout(this.pollingTimersSimulation[timerKey])
          delete this.pollingTimersSimulation[timerKey]
        }
        if (r.status === 200 && this.loadingSimulacoes === 0) {
          this.$showSnack({
            text: 'Simulações finalizadas',
            button: {
              text: 'Ver',
              callback: () => {
                if (this.$route.name !== 'simulador.selecionar') {
                  this.$router.push({ name: 'simulador.selecionar' })
                }
              },
            },
          })
        }
      }
    },
    onReloadBanks() {
      this.atualizando = true
      console.log('TODOS')
      this.getAccounts()
    },
    onReloadOneBank(bank) {
      this.atualizando = true
      this.accountAtt = bank
      this.getAccounts()
    },
    goTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      })
    },
    onScroll(e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset || e.target.scrollTop || 0
      this.toTop = top > 130
    },
    toAccounts() {
      if (this.$route.name !== 'contas') {
        this.$router.push({ name: 'contas' })
      }
    },
    toSimulador() {
      if (!this.$canAccessRoute('simulador.selecionar')) {
        this.$showSnack({
          text: CANT_ACCESS_FUNCTION,
          button: true,
        })
        return
      }
      if (this.$route.name !== 'simulador.selecionar') {
        this.$router.push({ name: 'simulador.selecionar' })
      }
    },
    seeDetails() {
      GlobalBus.$emit(MODAL.SIMULATOR_DETAILS, true)
    },
    expandedPanel() {
      this.expandPanel = !this.expandPanel
    },
    toggleDock() {
      this.dockCollapsed = !this.dockCollapsed
      writeDockCollapsed(this.dockCollapsed)
    },
    getAccounts() {
      if (!this.usuarioAtual.IS_CLIENTE) {
        return
      }
      if (this.loadingAccounts) {
        return
      }
      this.loadingAccounts = true
      con.get(adicionarTransacao.bancos.contas_cliente).then((r) => {
        this.loadingAccounts = false

        if (r && r.status === 200) {
          let has_updating, has_error, message

          if (this.accountAtt) {
            this.accounts = possivelJSON(r.value).filter((v, i) => {
              return v.id_conta === this.accountAtt
            })
            has_updating = this.accounts[0].status === 'Atualizando'
            has_error =
              this.accounts[0].status !== 'ok' &&
              this.accounts[0].status !== 'Atualizando' &&
              this.accounts[0].status !== 'Aguardando confirmação'

            if (this.accounts[0].nome.includes('CEI')) {
              message = 'Contas atreladas ao CEI atualizadas'
            }
          } else {
            this.accounts = possivelJSON(r.value).filter((v, i) => {
              return v.codigo !== -1
            })
            has_updating = this.accounts.find((v, i) => {
              return v.codigo !== -1 && v.status === 'Atualizando'
            })
            has_error = this.accounts.find((v, i) => {
              return (
                v.codigo !== -1 &&
                v.status !== 'ok' &&
                v.status !== 'Atualizando' &&
                v.status !== 'Aguardando confirmação'
              )
            })
          }

          if (has_updating) {
            clearTimeout(this.pollingTimerAccounts)
            this.pollingTimerAccounts = setTimeout(() => {
              if (!this.isComponentDestroyed) this.getAccounts()
            }, 8000)
          } else {
            if (this.$route.name !== 'contas') {
              this.$showSnack({
                text: has_error
                  ? 'Não conseguimos atualizar todas as contas'
                  : message || 'Contas Atualizadas',
                button: {
                  text: 'Ver',
                  callback: () => {
                    if (this.$route.name !== 'contas') {
                      this.$router.push({ name: 'contas' })
                    }
                  },
                },
              })
            }
            this.atualizando = false
            this.accountAtt = false
          }
        }
      })
    },

    // Anuncia o release atual (@modules/global/constants/CurrentRelease.js)
    // usando o modal de anúncio dedicado (release-announcement.vue, um
    // carrossel — um slide por feature). O anúncio é de uma vez só: encerrá-lo
    // de qualquer forma marca a version como vista. "Ver mais tarde" é a única
    // saída que o traz de volta, no dia seguinte. Para anunciar o PRÓXIMO
    // release, edite só o CurrentRelease.js. `expiresAt` (opcional) some com
    // o anúncio depois de uma data, independente de ter sido dispensado.
    showReleaseModal() {
      if (this.shouldHideReleaseModal()) {
        return
      }
      if (isReleaseExpired(CURRENT_RELEASE.expiresAt)) {
        return
      }
      if (isReleaseDismissed(CURRENT_RELEASE.version)) {
        return
      }

      setTimeout(() => {
        GlobalBus.$emit(MODAL.RELEASE_ANNOUNCEMENT)
      }, 100)
    },

    shouldHideReleaseModal() {
      return this.$currentUser().IS_CLIENTE
    },
  },
}
</script>

<template>
  <!-- ★ Modo restrito (`meta.restrito`): SÓ o `<RouterView>` (que chega pelo
       slot, `app.vue:110-112`) dentro de um `<v-app>` próprio. O `<v-app>`
       tem que ser daqui porque o das duas navs mora DENTRO delas — o da v1
       dentro do `NavBar`, o da v2 dentro do `NavegacaoV2Shell` — e sem
       nenhum ancestral `v-application` os componentes Vuetify da view
       perdem todo o estilo. Nada mais entra neste ramo, por desenho: é a
       única forma de o resultado ser igual nas duas versões de nav.
       ⚠️ Os modais globais (Snackbar/SnackModal/GlobalModals) ficam de fora
       junto com o resto — a view da Lista de Espera desenha erro na própria
       tela (`view-lista-espera.vue`, bloco `v-else-if="erro"` e a prop
       `:erro` da pergunta), e o `$showSnack` dela é canal secundário.
       ★ [owner, 21/09/2026] `rounded` TAMBÉM aqui: é a classe que liga o
       `style-rounded.sass` (raio 8px, 36px e peso 500 do `.btn`, raio dos
       inputs e dos cards). O ramo normal a põe na raiz (`<div class="rounded">`
       abaixo); sem ela, a Lista de Espera desenhava o `.btn` legado (2px de
       raio, 48px, GeneralSans 600) — *"o botão tá estranho, tipografia errada,
       sem radius, sem altura correta"*. -->
  <v-app v-if="rotaRestrita" class="rota-restrita rounded">
    <slot />
  </v-app>
  <!-- `nav-v2` marca a versão de nav ativa — o <style> abaixo usa isso pra
       restringir o padding-right ao v1, sem tirar as classes de estado da
       raiz (elas continuam valendo nas duas versões, pra _modal.sass
       reposicionar modal e pra esconder o dock flutuante). Comentário fora
       da expressão `:class` de propósito: `//` DENTRO de um objeto passado
       como atributo Vue é frágil a qualquer normalização de whitespace do
       build, que comentaria 'nav-v2'/'has-cc-guide'/'has-ff-ia-panel'
       junto. -->
  <div
    v-else
    v-scroll="onScroll"
    class="rounded"
    :class="{
      'aawz-dock-collapsed': dockCollapsed,
      'nav-v2': navUsaV2,
      'has-cc-guide': ccGuideOpen,
      'has-ff-ia-panel': ffIaSqueezeAtivo,
      'has-consultor-panel': consultorSqueezeAtivo,
      'em-rota-imersiva': rotaImersiva,
    }"
    :style="{ '--ia-painel-top-offset': iaPainelTopOffset }"
  >
    <NavegacaoV2Shell
      v-if="navUsaV2"
      :content-padding-right="contentPaddingRightV2"
      :sem-sidebar="rotaImersiva"
    >
      <slot />
    </NavegacaoV2Shell>
    <!-- Nav v1 não tem "sem-sidebar": o `<v-app>` dela mora dentro do NavBar e
         o "Voltar para Gestão" só tem alvo de teleport na topbar v2 — por isso a
         imersiva é gateada por `isNav2026Enabled` em `podeVerIaDriven` até a v1
         ter suporte, e aqui o slot NUNCA vai nu sem `<v-app>`. -->
    <NavBar v-else>
      <slot />
    </NavBar>
    <SimuladorDetalhes />
    <ConversaoRating />
    <Snackbar />
    <BigSnackbar />
    <Modal />
    <SnackModal />
    <TheNewVersionModal />
    <ModalVideos />
    <ModalReleaseNotes />
    <ModalReleaseNotesClient />
    <SendComponent />
    <ModalQrcodeConexao />
    <ModalTermosAtendimento />
    <TriggerSuggesterModal />
    <GlobalModals />
    <!-- Montados no layout (fora das rotas) para sobreviver à troca de rota; por isso
         precisam do gate da flag aqui — o `can_show` da rota não os alcança. -->
    <CentralConfigGuideDrawer v-if="jornadaVisivel" />
    <!-- Tour guiado da Jornada (overlay com furo de luz + cursor). Mora aqui
         pelo MESMO motivo do drawer acima: etapas que atravessam telas
         (Clientes → Simulação, no Fee Fixo) matariam um tour montado na view.
         Sob a mesma flag — sem a Jornada não há passo a guiar. -->
    <CentralConfigTourGuiado v-if="jornadaVisivel" />
    <!-- Idem: painel lateral do Especialista Fee-Based. `feeFixoIaVisivel` já
         combina as duas flags do módulo (FEE_FIXO + IA_FEE_FIXO) com o
         escopo por rota (`emFeeFixo`) — ver os computeds acima. -->
    <FeeFixoIaEspecialista v-if="feeFixoIaVisivel" />

    <ConsultorPainel v-if="consultorPainelVisivel" />

    <!-- Trilho compartilhado dos FABs flutuantes: adjacência real via
         flexbox (row-reverse — primeiro filho no DOM fica mais à direita)
         em vez de cada widget calcular seu próprio `right` fixo assumindo
         quais vizinhos existem. OptionsTourManual (renderizado por cada
         view, não daqui) se portaliza pra dentro via #aawz-floating-dock. -->
    <div :id="FLOATING_DOCK_ID" class="aawz-floating-dock v-application">
      <AtendimentoPopup />
      <ChatIaPopUp />
    </div>
    <div
      style="
        z-index: 7;
        align-items: flex-end;
        display: flex;
        flex-direction: row;
        position: fixed;
        bottom: 16px;
        right: 16px;
      "
      class="v-application"
    >
      <v-fab-transition
        v-if="!usuarioAtual.IS_CLIENTE && !paginaAtual.includes('simulador')"
      >
        <div
          v-show="loadingSimulacoes > 0 && show_simulacoes_running"
          :style="{
            'z-index': 3,
          }"
          class="dont-show-print"
        >
          <v-expansion-panels dark>
            <v-expansion-panel @click="expandedPanel">
              <v-expansion-panel-header>
                <v-row
                  :style="{
                    'margin-right': '10px',
                  }"
                >
                  <div class="col-auto d-flex flex-inline">
                    <div style="position: absolute; top: 0; right: 0">
                      <v-btn
                        icon
                        small
                        @click="show_simulacoes_running = false"
                      >
                        <v-icon small> mdi-close-circle </v-icon>
                      </v-btn>
                    </div>
                    <h2
                      class="list-cards__card__header__title"
                      :style="{
                        color: 'white',
                        'margin-bottom': '0px !important',
                        'font-size': expandPanel ? '20px' : '',
                      }"
                    >
                      Simulações
                    </h2>
                  </div>
                  <div
                    style="margin-left: 10px"
                    class="list-cards__card__header__resume v-applicaiton"
                  >
                    <v-progress-circular
                      indeterminate
                      color="white"
                      size="10"
                      width="1"
                    >
                    </v-progress-circular>
                  </div>
                </v-row>
                <template v-slot:actions>
                  <v-icon color="white" class="text-white"> mdi-plus </v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="v-application--is-ltr">
                <div
                  class="d-flex flex-row"
                  style="margin-bottom: 10px; justify-content: space-between"
                >
                  <div>
                    <p style="margin-bottom: 10px; color: white">
                      {{
                        loadingSimulacoes === 1
                          ? `${loadingSimulacoes} simulação`
                          : `${loadingSimulacoes} simulações`
                      }}
                    </p>
                    <div
                      style="cursor: pointer; color: white"
                      @click="seeDetails"
                    >
                      <p style="text-decoration: underline; color: white">
                        <strong>Ver detalhes</strong>
                      </p>
                    </div>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-fab-transition>
      <v-fab-transition v-if="usuarioAtual.IS_CLIENTE">
        <div
          v-show="atualizando"
          :style="{
            'z-index': 3,
          }"
          class="dont-show-print"
        >
          <!-- style="background-color: var(--dark)" -->
          <v-expansion-panels v-model="panel" dark>
            <v-expansion-panel @click="expandedPanel">
              <v-expansion-panel-header>
                <v-row
                  :style="{
                    'margin-right': '10px',
                  }"
                >
                  <div class="col-auto d-flex flex-inline">
                    <h2
                      class="list-cards__card__header__title"
                      :style="{
                        color: 'white',
                        'margin-bottom': '0px !important',
                        'font-size': !expandPanel ? '20px' : '',
                      }"
                    >
                      {{ expandPanel ? 'CI' : 'Atualizando Contas' }}
                    </h2>
                  </div>
                  <div
                    style="margin-left: 10px"
                    class="list-cards__card__header__resume v-applicaiton"
                  >
                    <v-progress-circular
                      indeterminate
                      color="white"
                      size="10"
                      width="1"
                    >
                    </v-progress-circular>
                  </div>
                </v-row>
                <template v-slot:actions>
                  <v-icon color="white" class="text-white"> mdi-plus </v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="v-application--is-ltr">
                <div
                  class="d-flex flex-row"
                  style="margin-bottom: 10px; justify-content: space-between"
                >
                  <div>
                    <p style="margin-bottom: 10px; color: white">{{
                      accounts.length === 1
                        ? `${accounts[0].nome}`
                        : `${accounts.length} instituições`
                    }}</p>
                    <div
                      style="cursor: pointer; color: white"
                      @click="toAccounts"
                    >
                      <p style="text-decoration: underline; color: white">
                        <strong>ver detalhes</strong>
                      </p>
                    </div>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-fab-transition>

      <!-- remove without use in moment -->
      <ChatPopup
        v-if="
          !($route.name || '').includes('workspace') &&
          !$currentUser().IS_CLIENTE &&
          false
        "
        class="ml-3"
      />
      <v-btn
        v-show="toTop"
        dark
        fab
        class="dont-show-print ml-3"
        @click="goTop"
      >
        <v-icon>mdi-chevron-up</v-icon>
      </v-btn>
    </div>

    <ReleaseAnnouncement />

    <FloatingDockToggle
      v-if="hasDockWidgets"
      :collapsed="dockCollapsed"
      @toggle="toggleDock"
    />
  </div>
</template>

<style scoped>
@media print {
  .dont-show-print {
    display: none !important;
  }
}
</style>

<style lang="sass">
$body-font-family: "Geist" !important
$title-font: "Geist" !important

.border-right
  border-right: 1px dashed #E4E0E6

.title
  font-family: 'Geist' !important

.v-divider
  display: block !important
  margin-top: 0 !important
  margin-bottom: 0 !important
  border: solid !important
  border-color: rgba(0,0,0,.12) !important
  border-width: thin 0 0 0 !important

.v-btn
  text-transform: initial !important
  letter-spacing: initial !important
  &.v-btn--fab
    background-color: var(--primary) !important

.v-tab
  text-transform: initial !important

.full-screen
  z-index: 1000
  position: fixed
  top: 0
  left: 0
  background: var(--gray-2)
  width: 100vw
  height: 100vh

.default-card
  padding: 24px 30px
  margin-bottom: 12px

// Trilho dos FABs flutuantes (Atendimento, Chat-IA, Tour, Especialista
// Fee-Based): cada widget vira um item de flex normal (sem position:fixed
// próprio) em vez de calcular o próprio `right` assumindo quais vizinhos
// existem. Flexbox empacota automaticamente os que estiverem presentes —
// sem gap fantasma quando um widget falta (ex.: white-label sem a feature
// Atendimento, ou fora das rotas do módulo Fee Fixo).
.aawz-floating-dock
  position: fixed
  bottom: 16px
  right: 40px
  z-index: 7
  display: flex
  flex-direction: row-reverse
  align-items: flex-end
  gap: 16px
  // Nunca overflow:hidden aqui — os painéis expandidos (position:absolute
  // relativo a cada widget) precisam poder crescer pra fora da fileira.

// Dock recolhível dos atalhos flutuantes. Trilho compartilhado
// (#aawz-floating-dock: Atendimento + Chat-IA + Tour portalizado — ver
// componente) desliza inteiro numa regra só, já que agora são descendentes
// DOM reais do trilho (inclusive o Tour, antes portalizado pro body e por
// isso preso a um evento GlobalBus à parte — não é mais necessário).
// O FAB do guia da Central de Configuração (.cc-fab) acompanha o mesmo
// recolhimento do dock. O antigo Agente CRM 360 foi descontinuado (virou
// AAWZ Intelligence) e saiu daqui.
.aawz-floating-dock,
.cc-fab
  transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)

.aawz-dock-collapsed
  .aawz-floating-dock,
  .cc-fab
    // +720px cobre o pior caso: o chat de IA ABERTO (painel ~500px de largura,
    // position:absolute, nao soma na largura do root) somado ao maior offset à
    // direita. Garante que todos — FABs e paineis abertos — saiam da viewport.
    transform: translateX(calc(100% + 720px))

// Guia (drawer) fixo da Central de Configuração / painel do Especialista
// Fee-Based: quando um dos dois está aberto, desloca o conteúdo do layout
// para a esquerda para não ficar embaixo do painel (v1) e reposiciona
// qualquer modal `default-right-dialog` aberto (_modal.sass) — as duas coisas
// dependem da CLASSE estar presente na raiz, então `has-cc-guide`/
// `has-ff-ia-panel` ficam sempre ligadas ao estado do painel, nas DUAS
// versões de nav. Só o `padding-right` (que squeezaria o topbar do
// NavegacaoV2Shell junto, pedido do John 05/08/2026) fica restrito a
// `:not(.nav-v2)` — em nav v2 o squeeze do conteúdo vai por
// `content-padding-right` (ver `contentPaddingRightV2` acima e
// `navegacao-v2-shell.vue`).
//
// `padding-right` mora DENTRO da própria regra da classe (não em `:style`
// inline) — é o padrão que garante a transição: alternar uma classe cujo
// próprio seletor já declara `padding-right` + `transition: padding-right` é
// robusto (o browser sempre tem um valor "antes" definido — 0/ausente — e um
// "depois" na mesma recalculação de estilo); setar o VALOR via inline style
// na mesma tick em que a classe habilitadora do `transition-property` é
// adicionada é frágil e nem sempre anima (a computed anterior,
// `contentPaddingRight`, fazia isso). A prioridade entre os dois painéis
// (Jornada vence) é resolvida ANTES daqui, no computed `ffIaSqueezeAtivo` —
// só uma das duas classes fica ativa por vez, então não há disputa de ordem
// entre `.has-cc-guide`/`.has-ff-ia-panel` no stylesheet.
.has-cc-guide,
.has-ff-ia-panel,
.has-consultor-panel
  transition: padding-right 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)

  // Atalhos flutuantes (dock) são position:fixed e ficariam por cima do
  // painel; enquanto qualquer um deles está aberto, escondemos o dock para
  // não sobrepor. Vale nas duas versões de nav. No Hub isso resolve também
  // uma duplicidade de porta: o FAB do chat de IA e o painel do Consultor na
  // mesma tela seriam duas entradas para a mesma IA.
  .aawz-floating-dock,
  .floating-dock-toggle
    display: none !important

.has-cc-guide:not(.nav-v2)
  padding-right: 380px

.has-ff-ia-panel:not(.nav-v2),
.has-consultor-panel:not(.nav-v2)
  // Responsivo (33vw entre 420-640px) — como é valor ESTÁTICO na regra da
  // classe (não JS), o browser recalcula sozinho a cada resize da janela,
  // sem depender de um computed do Vue reavaliar o inline style.
  padding-right: var(--ia-painel-largura)

.em-rota-imersiva
  .aawz-floating-dock,
  .floating-dock-toggle
    display: none !important

// ★ [owner, 21/09/2026] O `<html>` do app tem `overflow: hidden`
// (`public/index.html`): quem rola é SEMPRE um container interno — o `v-main`
// das navs. No modo restrito não existe nenhum, e a tela cortava embaixo sem
// scroll (*"se tiver algo de cards aberto, lá embaixo fica cortado"*). A
// casca do próprio `<v-app>` vira o container.
.rota-restrita .v-application--wrap
  height: 100vh
  min-height: 100vh
  overflow-y: auto
</style>
